export class SetupMongoAtlasPrivateLinkResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetupMongoAtlasPrivateLinkResponse.attributeTypeMap;
    }
    constructor() {
    }
}
